// Thin wrapper over lucide-react. Centralizing here lets us swap libraries later
// and ensures consistent stroke / size across the app.

import {
  DollarSign, TrendingUp, Scale, Undo2, LayoutDashboard, CloudUpload, Boxes,
  FileSpreadsheet, Settings, Bell, Search, UploadCloud, Calendar, ChevronDown,
  ChevronRight, ChevronLeft, Filter, Download, Zap, AlertTriangle, MailQuestion,
  Sparkles, Send, CheckCircle2, CheckCircle, Loader, Loader2, AlertCircle, Database, FolderOpen,
  Route, FileQuestion, File, RotateCcw, MoreHorizontal, Eye, EyeOff, Plus, X,
  Mailbox, Plane, Truck, Package, Globe, Compass, Mail, Trophy, Percent, Timer,
  Reply, GitCompare, Cpu, Star, Info, ShieldCheck, Save, UserPlus, Key,
  ArrowRightLeft, ArrowRight, SlidersHorizontal, Users, BadgeDollarSign,
  MessageSquare, History, Grid3X3, List, FileDown, LayoutTemplate, FileBarChart,
  UserSquare, CircleDollarSign, Check, Sigma, Clock, MapPin, Layers, Wallet,
  FileText, RefreshCw, Activity, Tag, Handshake, BookOpen, Home, GripVertical,
  MoveLeft, MoveRight, LogOut, User, Briefcase, TrendingDown, ChevronUp,
  Play, BarChart2, Receipt, Edit2, MinusCircle, XCircle, Trash2, CreditCard,
} from 'lucide-react'

const map = {
  'dollar-sign': DollarSign, 'trending-up': TrendingUp, 'scale': Scale, 'undo-2': Undo2,
  'layout-dashboard': LayoutDashboard, 'cloud-upload': CloudUpload, 'boxes': Boxes,
  'file-spreadsheet': FileSpreadsheet, 'settings': Settings, 'bell': Bell, 'search': Search,
  'upload-cloud': UploadCloud, 'calendar-range': Calendar, 'chevron-down': ChevronDown,
  'chevron-right': ChevronRight, 'chevron-left': ChevronLeft, 'filter': Filter, 'download': Download,
  'zap': Zap, 'alert-triangle': AlertTriangle, 'mail-question': MailQuestion, 'sparkles': Sparkles,
  'send': Send, 'check-circle-2': CheckCircle2, 'check-circle': CheckCircle,
  'loader': Loader, 'loader-2': Loader2, 'alert-circle': AlertCircle,
  'database': Database, 'folder-open': FolderOpen, 'route': Route, 'file-question': FileQuestion,
  'file': File, 'rotate-cw': RotateCcw, 'rotate-ccw': RotateCcw, 'more-horizontal': MoreHorizontal, 'eye': Eye,
  'plus': Plus, 'x': X, 'mailbox': Mailbox, 'plane': Plane, 'truck': Truck, 'package': Package,
  'globe': Globe, 'compass': Compass, 'mail': Mail, 'trophy': Trophy, 'percent': Percent,
  'timer': Timer, 'reply': Reply, 'git-compare': GitCompare, 'cpu': Cpu, 'star': Star,
  'info': Info, 'shield-check': ShieldCheck, 'save': Save, 'user-plus': UserPlus, 'key': Key,
  'arrow-right-left': ArrowRightLeft, 'arrow-right': ArrowRight, 'sliders-horizontal': SlidersHorizontal,
  'users': Users, 'badge-dollar-sign': BadgeDollarSign, 'message-square': MessageSquare,
  'history': History, 'grid-3x3': Grid3X3, 'list': List, 'file-down': FileDown,
  'layout-template': LayoutTemplate, 'file-bar-chart': FileBarChart, 'user-square': UserSquare,
  'circle-dollar-sign': CircleDollarSign, 'check': Check, 'sigma': Sigma, 'clock': Clock,
  'map-pin': MapPin, 'layers': Layers, 'wallet': Wallet,
  'file-text': FileText, 'refresh-cw': RefreshCw,
  'activity': Activity, 'tag': Tag, 'handshake': Handshake, 'book-open': BookOpen,
  'home': Home, 'grip-vertical': GripVertical, 'move-left': MoveLeft, 'move-right': MoveRight,
  'eye-off': EyeOff, 'log-out': LogOut, 'user': User, 'briefcase': Briefcase,
  'loader-circle': Loader, 'trending-down': TrendingDown, 'chevron-up': ChevronUp,
  'play': Play, 'bar-chart-2': BarChart2, 'receipt': Receipt, 'edit-2': Edit2,
  'minus-circle': MinusCircle, 'x-circle': XCircle, 'trash-2': Trash2,
  'credit-card': CreditCard,
} as const

export type IconName = keyof typeof map

interface Props {
  name: IconName
  className?: string
}

export function Icon({ name, className = 'w-4 h-4' }: Props) {
  const C = map[name]
  if (!C) return null
  return <C className={className} />
}
